import { useMatch } from "@tanstack/react-router";
import { type PropsWithChildren } from "react";

import { AthleteSpaceRepositoryProviders } from "src/components/AthleteSpaceRepositoryProviders";
import { OrganizationSpaceRepositoryProviders } from "src/components/OrganizationSpaceRepositoryProviders";
import { PrivateSpaceRepositoryProviders } from "src/components/PrivateSpaceRepositoryProviders";

export function ScopedRepositoryProviders(props: PropsWithChildren) {
  const organizationSlug = useMatch({
    from: "/_auth/_coach/orgs/$slug",
    shouldThrow: false,
    select: (match) => match.params.slug,
  });
  const athleteId = useMatch({
    from: "/_auth/_coach/athletes/$athleteId",
    shouldThrow: false,
    select: (match) =>
      match.status === "success" ? match.params.athleteId : undefined,
  });

  if (organizationSlug) {
    return (
      <OrganizationSpaceRepositoryProviders organizationSlug={organizationSlug}>
        {props.children}
      </OrganizationSpaceRepositoryProviders>
    );
  }

  if (athleteId) {
    return (
      <AthleteSpaceRepositoryProviders athleteId={athleteId}>
        {props.children}
      </AthleteSpaceRepositoryProviders>
    );
  }

  return (
    <PrivateSpaceRepositoryProviders>
      {props.children}
    </PrivateSpaceRepositoryProviders>
  );
}
